import Breadcrumbs from "@mui/material/Breadcrumbs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  adDetails,
  editAd
} from "../../../api/webContentRequets";
import ScreenTitle from "../../../components/ScreenTitle";
import { SimpleDialog } from "../../../components/dialogs";
import { ErrorMessage, Loader } from "../../../components/smallComponents";
import commonStyle from "../../../style/commonStyle.module.css";
import useDocumentTitle from "../../../useDocumentTitle";
import QuestionsForm from "./AdForm";


export default function EditAd() {
  useDocumentTitle("Edit Ad");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { userInfo } = useSelector((state) => state.userLogin);
  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo.data.token}`,
    },
  };
  const [reqStatus, setReqStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });
  const [adInfo, setAdInfo] = useState({});

  const [saveStatus, setSaveStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });

  useEffect(() => {
    const getAdDetails = async () => {
      try {
        setReqStatus((preState) => ({
          ...preState,
          loading: true,
        }));

        const responseData = await adDetails(id, config, dispatch);
        if (responseData.data.success) {
          setReqStatus((preState) => ({
            ...preState,
            loading: false,
            success: true,
          }));
          setAdInfo(responseData.data.data);
        } else {
          throw responseData.data.message;
        }
      } catch (error) {
        setReqStatus((preState) => ({
          ...preState,
          loading: false,
          error: error,
        }));
      }
    };

    getAdDetails();
  }, [dispatch]);

  //  dialog
  const handleSave = async (values) => {
    let postValues = {
      type: values.type,
      image: values.image,
      uri: values.uri,
    };
    try {
      setDialog(true);
      setSaveStatus({ ...saveStatus, loading: true });
      const responseData = await editAd(id, postValues, config, dispatch);
      if (responseData.data.success) {
        setSaveStatus({ ...saveStatus, loading: false, success: true });
      } else {
        throw responseData.data.message;
      }
    } catch (error) {
      setSaveStatus({ ...saveStatus, loading: false, error: error });
    }
  };
  const [dialog, setDialog] = useState(false);

  const closeDialogWithSuccess = () => {
    setDialog(false);
    navigate("/web-content/ads", { replace: true, from: location });
  };

  return (
    <div className={commonStyle.pageContainer}>
      <SimpleDialog
        title="Add New Ad"
        successMessage="New ad added successfully."
        isDialogOpen={dialog}
        closeDialog={() => setDialog(false)}
        loading={saveStatus.loading}
        loadingMessage="Processing request..."
        success={saveStatus.success}
        error={saveStatus.error}
        confirmAction={closeDialogWithSuccess}
      />

      <div className="w-full p-8">
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink underline="hover" color="inherit" to="/">
            Home
          </NavLink>
          <NavLink underline="hover" color="inherit" to="/web-content/ads">
            Ads
          </NavLink>
          <NavLink
            underline="hover"
            color="text.primary"
            to={`/web-content/ads/edit/${id}`}
            aria-current="page"
          >
            Edit Ad
          </NavLink>
        </Breadcrumbs>
        <ScreenTitle title="Edit Ad" />
        {reqStatus.loading ? (
          <Loader mess="Requesting..." />
        ) : reqStatus.success ? (
          <QuestionsForm
            type="edit"
            onSave={handleSave}
            initialValues={adInfo}
          />
        ) : reqStatus.error ? (
          <ErrorMessage mess={reqStatus.error} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
